import Chart from "../components/global/chart";
import { db } from "../firebase";
import { useState, useEffect } from "react";

const Charts = () => {
  const [latestCharts, setLatestCharts] = useState();

  useEffect(() => {
    const ref = db.collection("blogs/blog/Charts");
    ref
      .orderBy("createdate", "desc")
      .get()
      .then((querySnapshot) => {
        let documents = [];
        querySnapshot.forEach((doc) => {
          documents.push({ ...doc.data(), id: doc.id });
        });
        setLatestCharts(documents);
      });
  }, []);
  return (
    <div className="charts-page">
      <div className="charts">
        <div className="container">
          <div className="head">
            <div className="title">
              <h1>أعلى الترتيبات</h1>
              <h4>في راب سين</h4>
            </div>
          </div>
          <Chart charts={latestCharts} />
        </div>
      </div>
    </div>
  );
};

export default Charts;
